import Vue from 'vue'

// 在原地址展示访问状态，失败时不加载画册业务组件。
export const albumAccess = Vue.observable({pending: true, ready: false, error: ''})



// WEBPACK FOOTER //
// ./src/utils/album-access.js